import { __decorate, __metadata } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { StandardSize } from '../pvd-utils/enums/size.js';

var LabelVariant;
(function (LabelVariant) {
    LabelVariant["primary"] = "primary";
    LabelVariant["secondary"] = "secondary";
})(LabelVariant || (LabelVariant = {}));
var LabelIndicator;
(function (LabelIndicator) {
    LabelIndicator["optional"] = "optional";
    LabelIndicator["required"] = "required";
})(LabelIndicator || (LabelIndicator = {}));
const DEFAULT_INDICATOR_OPTIONAL_TEXT = LabelIndicator.optional;
const DEFAULT_SIZE = StandardSize.medium;
const DEFAULT_VARIANT = LabelVariant.primary;
const LABEL_PROTECTED_ATTR_MAP = new Map([['for', 'pvd-for']]);
/**
 * Providence Label component.
 * @see {@link https://providence.fmr.com/4.x/components/label/label.html|Label documentation}
 */
class PvdLabel extends PvdSlotifyBaseComponent {
    constructor() {
        super(...arguments);
        this.pvdIndicatorOptionalText = DEFAULT_INDICATOR_OPTIONAL_TEXT;
        this.pvdSize = DEFAULT_SIZE;
        this.pvdVariant = DEFAULT_VARIANT;
        // #endregion
    }
    // #endregion
    // #region private methods
    /**
     * Sets attributes on the label element that are coming from pvdNativeLabelAttributes
     * @param prevAttr optional, if user updates pvdNativeLabelAttributes, this will remove/update existing attributes
     */
    setNativeLabelAttributes(prevAttr) {
        const targetElement = this.querySelector('label');
        this.setNativeAttributes(this.pvdNativeLabelAttributes, LABEL_PROTECTED_ATTR_MAP, targetElement, prevAttr);
    }
    // #endregion
    // #region LitElement lifecycles
    updated(changedProperties) {
        super.updated(changedProperties);
        if (this.pvdNativeLabelAttributes) {
            const prevAttr = changedProperties.get('pvdNativeLabelAttributes');
            // if native attributes are being set, go through the logic of applying attributes to target element
            this.setNativeLabelAttributes(prevAttr);
        }
    }
    /**
     * Render native label element only if the consumer provided a for
     * attribute; otherwise, style a div as a label. This allows for the
     * Providence Label component to label a group as well as a form
     * control.
     */
    renderLabel(text) {
        return this.pvdFor
            ? x `<label class="pvd-label__label" for="${this.pvdFor}">${text}</label>`
            : x `<div class="pvd-label__label" id="${l(this.pvdId)}">${text}</div>`;
    }
    renderIndicator() {
        switch (this.pvdIndicator) {
            case LabelIndicator.required:
                return x `<span aria-hidden="true" class="pvd-label__indicator pvd-label__indicator--required">*</span>`;
            case LabelIndicator.optional:
                return x `<span class="pvd-label__indicator">(${this.pvdIndicatorOptionalText})</span>`;
            default:
                return x ``;
        }
    }
    renderAnnotation() {
        return this.isSlotUsed('annotation')
            ? x `<span class="pvd-label__annotation"><s-slot name="annotation"></s-slot></span>`
            : x `<s-slot name="annotation"></s-slot>`;
    }
    render() {
        const classMap = {
            default: `${this.constructor.namespace}-label-root`,
            modifierPrefix: 'pvd-label',
            modifiers: [
                {
                    condition: this.pvdSize !== StandardSize.small,
                    className: `${this.pvdSize}`,
                },
                {
                    condition: true,
                    className: this.pvdVariant,
                },
            ],
        };
        const indicator = this.renderIndicator();
        const annotation = this.renderAnnotation();
        const text = x `<s-slot>${this.pvdText}</s-slot>${indicator}${annotation}`;
        return x `<div class="${getClassName(classMap)}">${this.renderLabel(text)}</div>`;
    }
}
//#region Component configuration
PvdLabel.componentName = 'label';
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-for' }),
    __metadata("design:type", String)
], PvdLabel.prototype, "pvdFor", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-id' }),
    __metadata("design:type", String)
], PvdLabel.prototype, "pvdId", void 0);
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-indicator',
        ...PvdSlotifyBaseComponent.hasChanged(LabelIndicator),
    }),
    __metadata("design:type", String)
], PvdLabel.prototype, "pvdIndicator", void 0);
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-indicator-optional-text',
    }),
    __metadata("design:type", String)
], PvdLabel.prototype, "pvdIndicatorOptionalText", void 0);
__decorate([
    n({ type: Object, attribute: 'pvd-native-label-attributes' }),
    __metadata("design:type", Object)
], PvdLabel.prototype, "pvdNativeLabelAttributes", void 0);
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-size',
        ...PvdSlotifyBaseComponent.hasChanged([StandardSize.medium, StandardSize.large]),
    }),
    __metadata("design:type", Number)
], PvdLabel.prototype, "pvdSize", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-text' }),
    __metadata("design:type", String)
], PvdLabel.prototype, "pvdText", void 0);
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-variant',
        ...PvdSlotifyBaseComponent.hasChanged(LabelVariant),
    }),
    __metadata("design:type", String)
], PvdLabel.prototype, "pvdVariant", void 0);

export { DEFAULT_INDICATOR_OPTIONAL_TEXT, DEFAULT_SIZE, DEFAULT_VARIANT, LABEL_PROTECTED_ATTR_MAP, LabelIndicator, LabelVariant, PvdLabel };
//# sourceMappingURL=pvd-label.js.map
